/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/anchor-has-content */
import React, { Component } from 'react';
import { Container, Row, Col, FormFeedback, Form, Label, Input, Button, Modal, ModalBody } from 'reactstrap';
import { HelpTextHover } from './Tooltip';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import 'bootstrap/dist/css/bootstrap.min.css';
import { formatWithCommas, getTooltipValue, getInputName } from '../utils/Format';

export class StartingDialog extends Component {
    constructor(props) {
        super(props);
        this.preStateChangeValidate = this.preStateChangeValidate.bind(this);
        this.state = {
            validated: false,
            currentAgeInvalid: false,
            retirementAgeInvalid: false,
            currentCompInvalid: false,
            compRateInvalid: false,
        };
    }

    preStateChangeValidate(value, stateName) {
        if (stateName === "currentAge") {
            if (value >= 18 && value <= 99) {
                this.setState({ currentAgeInvalid: false });
            } else {
                this.setState({ currentAgeInvalid: true });
                return;
            }
        }

        if (stateName === "retirementAge") {
            if (value >= 18 && value <= 99) {
                this.setState({ retirementAgeInvalid: false });
            } else {
                this.setState({ retirementAgeInvalid: true });
                return;
            }
        }

        if (stateName === "currentComp") {
            if (value > 0) {
                this.setState({ currentCompInvalid: false });
            } else {
                this.setState({ currentCompInvalid: true });
                return;
            }
        }

        if (stateName === "compRate") {
            if (value > 0) {
                this.setState({ compRateInvalid: false });
            } else {
                this.setState({ compRateInvalid: true });
                return;
            }
        }

        if (!this.state.currentAgeInvalid && !this.state.currentCompInvalid && !this.state.retirementAgeInvalid && !this.state.compRateInvalid) {
            this.setState({ validated: true });
        } else {
            this.setState({ validated: false });
        }
    }

    render() {
        let audienceType = this.props.audience;
        let helpTextData = this.props.helpTextData;

        let CurrentCompTooltipText = getTooltipValue(helpTextData, audienceType, 1);
        let CompRateTooltipText = getTooltipValue(helpTextData, audienceType, 6);

        let inputData = this.props.inputData;

        let CurrentAgeName = getInputName(inputData, audienceType, 1);
        let RetirementAgeName = getInputName(inputData, audienceType, 2);
        let CurrentCompensationName = getInputName(inputData, audienceType, 3);
        let AnnualCompGrowthRateName = getInputName(inputData, audienceType, 4);

        return (
            <>
                <Modal autoFocus={false} isOpen={this.props.showModal} size="xl">
                    <ModalBody style={{ margin: "0", padding: "0px" }}>
                        <Row>
                            <Col xs={12} md={6} style={{ backgroundColor: "#eee" }}>
                                <img title="Aspire Logo" style={{ maxWidth: "100%" }} src="/Aspire-LogoDescriptor-Navy.png" alt="Aspire logo" />
                            </Col>
                            <Col className="g-4" xs={12} md={6}>
                                <Container className="mb-4">
                                    <Form noValidate validated="true" onSubmit={(evt) => this.props.handleModalSubmit(evt, this.state.validated)}>
                                        <Row>
                                            <Col>
                                                <Label for="currentAge">{CurrentAgeName} </Label>
                                                <Input invalid={this.state.currentAgeInvalid}
                                                    id="currentAge"
                                                    type="number"
                                                    autoFocus={true}
                                                    name="current_age"
                                                    onChange={(evt) => this.preStateChangeValidate(evt.target.value, "currentAge")} />
                                                <FormFeedback>Please enter a valid number.</FormFeedback>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <Label for="retirementAge">{RetirementAgeName} </Label>
                                                <Input invalid={this.state.retirementAgeInvalid}
                                                    id="retirementAge"
                                                    type="number"
                                                    name="retirement_age"
                                                    onChange={(evt) => this.preStateChangeValidate(evt.target.value, "retirementAge")} />
                                                <FormFeedback>Please enter a valid number.</FormFeedback>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <Label for="currentComp">{CurrentCompensationName} </Label>
                                                <a data-tooltip-id="CurrentComp"><HelpTextHover /></a>
                                                <ReactTooltip id="CurrentComp" aria-haspopup="true">{CurrentCompTooltipText}</ReactTooltip>
                                                <div className="input-group">
                                                    <div className="input-group-prepend">
                                                        <div className="input-group-text dollarPrepend">$</div>
                                                    </div>
                                                    <Input invalid={this.state.currentCompInvalid}
                                                        id="currentComp"
                                                        className="dollarPrependInput"
                                                        type="text" //this needs to be type=text to allow for formatting with commas
                                                        name="current_comp"
                                                        onBlur={(evt) => evt.target.value = formatWithCommas(evt.target.value)}
                                                        onChange={(evt) => this.preStateChangeValidate(evt.target.value, "currentComp")} />
                                                    <FormFeedback>Please enter a valid number.</FormFeedback>
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <Label for="compRate">{AnnualCompGrowthRateName} </Label>
                                                <a data-tooltip-id="CompRate"><HelpTextHover /></a>
                                                <ReactTooltip id="CompRate">{CompRateTooltipText}</ReactTooltip>
                                                <div className="input-group">
                                                    <Input invalid={this.state.compRateInvalid}
                                                        id="compRate"
                                                        className="percentAppendInput"
                                                        type="number"
                                                        name="comp_rate"
                                                        onBlur={(evt) => evt.target.value = formatWithCommas(evt.target.value)}
                                                        onChange={(evt) => this.preStateChangeValidate(evt.target.value, "compRate")} />
                                                    <div className="input-group-append">
                                                        <span className="input-group-text percentAppend">%</span>
                                                    </div>
                                                    <FormFeedback>Please enter a valid number.</FormFeedback>
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row className="mt-4">
                                            <Col>
                                                <Button style={{ width: "100%", margin: "auto", backgroundColor: "#003865" }} type="Submit">Submit</Button>
                                            </Col>
                                        </Row>
                                    </Form>
                                </Container>
                            </Col>
                        </Row>

                    </ModalBody>
                </Modal>
            </>
        );
    }
}
